module.exports = __webpack_public_path__ + "img/114721-OOR4RY-486.e10cfba5.jpg";